import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_id: '',
    unit_id: '',
    user_is_admin: '',
    user_name: '',
    user_is_pta: '',
    user_phone_no: '',
    callbackUrl: ''
  },
  mutations: {
    updateUser(state, data) {
      state.user_id = data.user_id || '',
      state.unit_id = data.unit_id || '',
      state.user_is_admin = data.user_is_admin || '',
      state.user_name = data.user_name || '',
      state.user_is_pta = data.user_is_pta || '',
      state.user_phone_no = data.user_phone_no || ''
    },
    setCallbackUrl(state, url) {
      state.callbackUrl = url
    },
    updateCates(state, cates) {
      console.log(cates)
      Object.keys(cates).forEach(c => {
        state[c] = cates[c]
      });
    }
  },
  actions: {
    updateUser({ commit }, data) {
      commit('updateUser', data)
    },
    setCallbackUrl({ commit }, url) {
      commit('setCallbackUrl', url)
    },
    updateCates({ commit }, cates) {
      commit('updateCates', cates)
    }
  },
});
